import localeAntd from 'antd/es/locale/en_US'
import labels from './en.json'
import labelsNew from './en_new.json'

export default {
  locale: 'en-US',
  localeAntd,
  messages: {
    ...labels,
    ...labelsNew
  },
}
